import { FormattedMessage } from 'react-intl';
// @flow weak

import React from 'react';
import bemify from 'bemify-js';

import Button from 'app/common/components/Button';
import Icon from 'app/common/components/Icon';
import 'app/common/components/LearnMoreErrorInfo.scss';

import type { KindType } from 'app/common/types';

type LearnMoreErrorInfoProps = {
  title: string,
  summary: string,
  helpLink: string,
  continueText: string,
  onClose: Function,
  className?: string,
  kind?: KindType,
};

const LearnMoreErrorInfo = (props: LearnMoreErrorInfoProps) => {
  const bem = bemify('learn-more-error-info');
  const { title, summary, helpLink, continueText, onClose } = props;

  return (
    <div className={bem()}>
      <Icon className="dashboard-modal__icon-alt" type="error" />
      <div className={bem('__title')}>{title}</div>
      <div className={bem('__description')}>{summary}</div>
      <div className={bem('__description')}>
        <FormattedMessage
          defaultMessage="There are a few things that could be going on."
          id="descriptions-possible-issues-explanation"
        />
      </div>
      <Button
        className={bem('__learn-more')}
        href={helpLink}
        kind="primary xlarge"
        tag="a"
        target="_blank"
      >
        <FormattedMessage defaultMessage="Learn More" id="buttons-learn-more" />
      </Button>
      <Button className={bem('__continue')} kind="as-link" onClick={onClose}>
        {continueText}
      </Button>
    </div>
  );
};

export default LearnMoreErrorInfo;
